"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentsSection = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faPencilAlt_1 = require("@fortawesome/free-solid-svg-icons/faPencilAlt");
const faClock_1 = require("@fortawesome/free-solid-svg-icons/faClock");
const faArrowRight_1 = require("@fortawesome/free-solid-svg-icons/faArrowRight");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const Widget_1 = require("../Widget");
const GroupWidgets_1 = require("../GroupWidgets");
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const WithSurveyContextHoc_1 = require("../../hoc/WithSurveyContextHoc");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const useSectionTemplate_1 = require("../../hooks/useSectionTemplate");
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const helpers = __importStar(require("evolution-common/lib/utils/helpers"));
const frontendHelper_1 = require("../../../services/display/frontendHelper");
const types_1 = require("evolution-common/lib/services/odSurvey/types");
const activityIconMapping_1 = require("evolution-common/lib/services/questionnaire/sections/visitedPlaces/activityIconMapping");
const SegmentsSection = (props) => {
    const { preloaded } = (0, useSectionTemplate_1.useSectionTemplate)(props);
    const iconPathsByMode = react_1.default.useMemo(() => {
        const iconPathsByMode = {};
        const modes = props.surveyContext.widgets['segmentMode'].choices;
        for (let i = 0, count = modes.length; i < count; i++) {
            const mode = modes[i].value;
            const iconPath = modes[i].iconPath;
            iconPathsByMode[mode] = iconPath;
        }
        return iconPathsByMode;
    }, []);
    const selectTrip = (tripUuid, e) => {
        if (e) {
            e.preventDefault();
        }
        props.startUpdateInterview({
            sectionShortname: 'segments',
            valuesByPath: { ['response._activeTripId']: tripUuid }
        });
    };
    if (!preloaded) {
        return react_1.default.createElement(LoadingPage_1.default, null);
    }
    helpers.devLog('%c rendering section ' + props.shortname, 'background: rgba(0,0,255,0.1);');
    const widgetsComponentsByShortname = {};
    // FIXME We need to make sure a widget by that name exists in the survey context
    const personTripsConfig = props.surveyContext.widgets['personTrips'];
    // Get the trips of the active journey/person
    const person = odSurveyHelper.getActivePerson({ interview: props.interview });
    if (person === null) {
        throw new Error('SegmentsSection: active person not found');
    }
    const journeys = odSurveyHelper.getJourneysArray({ person });
    if (journeys.length === 0) {
        throw new Error('SegmentsSection: there are no journeys');
    }
    const currentJourney = journeys[0];
    const trips = currentJourney.trips || {};
    const tripsList = [];
    const visitedPlaces = currentJourney.visitedPlaces || {};
    const selectedTrip = odSurveyHelper.getActiveTrip({ interview: props.interview, journey: currentJourney });
    const selectedTripId = selectedTrip ? selectedTrip._uuid : undefined;
    // setup widgets
    // FIXME It seems that the trips section widgets should be hard-coded. As it
    // is, they can be defined in the survey, but we need them by name later.
    // The whole widget configuration of the trips section should be revised.
    for (let i = 0, count = props.sectionConfig.widgets.length; i < count; i++) {
        const widgetShortname = props.sectionConfig.widgets[i];
        widgetsComponentsByShortname[widgetShortname] = (react_1.default.createElement(Widget_1.Widget, { key: widgetShortname, currentWidgetShortname: widgetShortname, nextWidgetShortname: props.sectionConfig.widgets[i + 1], sectionName: props.shortname, interview: props.interview, errors: props.errors, user: props.user, loadingState: props.loadingState, startUpdateInterview: props.startUpdateInterview, startAddGroupedObjects: props.startAddGroupedObjects, startRemoveGroupedObjects: props.startRemoveGroupedObjects, startNavigate: props.startNavigate }));
    }
    let tripSequence = 1;
    for (let i = 0, count = Object.keys(trips).length; i < count; i++) {
        const trip = trips[Object.keys(trips)[i]];
        const origin = trip._originVisitedPlaceUuid ? visitedPlaces[trip._originVisitedPlaceUuid] : null;
        const destination = trip._destinationVisitedPlaceUuid
            ? visitedPlaces[trip._destinationVisitedPlaceUuid]
            : undefined;
        if (!origin || !destination) {
            // We should not have a trip without origin or destination at this point
            throw new Error('SegmentsSection: origin or destination not found');
        }
        const actualOrigin = origin.shortcut
            ? (0, helpers_1.getResponse)(props.interview, origin.shortcut, origin)
            : origin;
        const actualDestination = destination.shortcut
            ? (0, helpers_1.getResponse)(props.interview, destination.shortcut, destination)
            : destination;
        // ignore all but the first trip if the origin is a loop activity. When loop activity is the first, we still need to ask the segments for it
        if (origin && origin._sequence !== 1 && types_1.loopActivities.includes(origin.activity || '')) {
            continue;
        }
        const isOnTheRoadOrLeisureStrollTrip = destination && types_1.loopActivities.includes(destination.activity || '');
        const tripPath = `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.trips.${trip._uuid}`;
        // for isOnTheRoadOrLeisureStrollTrip, we need next trip destination:
        const nextDestination = isOnTheRoadOrLeisureStrollTrip
            ? odSurveyHelper.getNextVisitedPlace({
                visitedPlaceId: trip._destinationVisitedPlaceUuid,
                journey: currentJourney
            })
            : undefined;
        const modeIcons = [];
        if (!(0, LodashExtensions_1._isBlank)(trip.segments)) {
            for (const segmentId in trip.segments) {
                const segment = trip.segments[segmentId];
                if (segment.mode) {
                    modeIcons.push(react_1.default.createElement(react_1.default.Fragment, { key: segment._uuid },
                        react_1.default.createElement("img", { src: iconPathsByMode[segment.mode], style: { height: '1.5em', marginLeft: '0.3em' }, alt: props.t(`segments:mode:short:${segment.mode}`) })));
                }
            }
        }
        // FIXME Extract the tripItem part to its own component
        const tripItem = (react_1.default.createElement("li", { className: `no-bullet survey-trip-item survey-trip-item-name${trip._uuid === selectedTripId ? ' survey-trip-item-selected' : ''}`, key: `survey-trip-item__${i}` },
            react_1.default.createElement("span", { className: "survey-trip-item-element survey-trip-item-sequence-and-icon" },
                react_1.default.createElement("em", null, props.t('survey:trip:tripSeq', { seq: tripSequence }))),
            react_1.default.createElement("span", { className: "survey-trip-item-element survey-trip-item-buttons" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faClock_1.faClock, style: { marginRight: '0.3rem', marginLeft: '0.6rem' } }),
                origin && origin.departureTime && (0, frontendHelper_1.secondsSinceMidnightToTimeStrWithSuffix)(origin.departureTime),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faArrowRight_1.faArrowRight, style: { marginRight: '0.3rem', marginLeft: '0.3rem' } }),
                destination &&
                    destination.arrivalTime &&
                    (0, frontendHelper_1.secondsSinceMidnightToTimeStrWithSuffix)(destination.arrivalTime),
                !selectedTripId && props.loadingState === 0 && (react_1.default.createElement("button", { type: "button", className: 'survey-section__button button blue small', onClick: (e) => selectTrip(trip._uuid, e), style: { marginLeft: '0.5rem' }, title: props.t('survey:trip:editTrip') },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faPencilAlt_1.faPencilAlt, className: "" }))))));
        tripsList.push(tripItem);
        if (origin && destination) {
            tripsList.push(react_1.default.createElement("li", { className: `no-bullet survey-trip-item survey-trip-item-description${trip._uuid === selectedTripId ? ' survey-trip-item-selected' : ''}`, key: `survey-trip-item-origin-destination__${i}` },
                react_1.default.createElement("span", { className: "survey-trip-item-element survey-trip-item-origin-description" },
                    react_1.default.createElement("img", { src: (0, activityIconMapping_1.getActivityMarkerIcon)(origin.activity), style: { height: '4rem' }, alt: props.t(`visitedPlaces/activities/${origin.activity}`) }),
                    react_1.default.createElement("span", null,
                        props.t(`survey:visitedPlace:activities:${origin.activity}`),
                        actualOrigin.name && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("em", null,
                                "\u00A0\u2022 ",
                                actualOrigin.name))))),
                react_1.default.createElement("span", { className: "survey-trip-item-element survey-trip-item-arrow" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faArrowRight_1.faArrowRight, style: { marginRight: '0.3rem', marginLeft: '0.3rem' } })),
                react_1.default.createElement("span", { className: "survey-trip-item-element survey-trip-item-destination-description" },
                    react_1.default.createElement("img", { src: (0, activityIconMapping_1.getActivityMarkerIcon)(destination.activity), style: { height: '4rem' }, alt: props.t(`visitedPlaces/activities/${destination.activity}`) }),
                    react_1.default.createElement("span", null,
                        props.t(`survey:visitedPlace:activities:${destination.activity}`),
                        actualDestination.name && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("em", null,
                                "\u00A0\u2022 ",
                                actualDestination.name))))),
                isOnTheRoadOrLeisureStrollTrip && nextDestination && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "survey-trip-item-element survey-trip-item-arrow" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faArrowRight_1.faArrowRight, style: { marginRight: '0.3rem', marginLeft: '0.3rem' } })),
                    react_1.default.createElement("span", { className: "survey-trip-item-element survey-trip-item-destination-description" },
                        react_1.default.createElement("img", { src: (0, activityIconMapping_1.getActivityMarkerIcon)(nextDestination.activity), style: { height: '4rem' }, alt: props.t(`visitedPlaces/activities/${nextDestination.activity}`) }),
                        react_1.default.createElement("span", null,
                            props.t(`survey:visitedPlace:activities:${nextDestination.activity}`),
                            nextDestination.name && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("br", null),
                                react_1.default.createElement("em", null,
                                    "\u00A0\u2022 ",
                                    nextDestination.name)))))))));
            tripsList.push(react_1.default.createElement("li", { className: `no-bullet survey-trip-item survey-trip-item-mode-icons${trip._uuid === selectedTripId ? ' survey-trip-item-selected' : ''}`, key: `survey-trip-item-origin-mode-icon__${i}` }, modeIcons));
        }
        tripSequence++;
        // For the selected trip, add the segments questions.
        if (selectedTripId && trip._uuid === selectedTripId) {
            const parentObjectIds = {};
            parentObjectIds['personTrips'] = trip._uuid;
            // FIXME The personTripsConfig is probably part of the
            // widgetsComponentsByShortname with a `Group` Widget, because
            // it is one of the widgets of the section. See if there's a way
            // to get it from there, or it at least avoid duplicating its
            // content. Maybe when the segments's section is completely
            // configurable, some of the widgets can actually be forced.
            tripsList.push(react_1.default.createElement("li", { className: "no-bullet", style: { marginTop: '-0.4rem' }, key: `survey-trip-item-selected__${i}` },
                react_1.default.createElement(GroupWidgets_1.GroupedObject, { widgetConfig: personTripsConfig, path: tripPath, shortname: "personTrips", loadingState: props.loadingState, objectId: trip._uuid, parentObjectIds: parentObjectIds, key: `survey-trip-item-selected-${trip._uuid}`, sequence: trip['_sequence'], section: 'segments', interview: props.interview, user: props.user, errors: props.errors, startUpdateInterview: props.startUpdateInterview, startAddGroupedObjects: props.startAddGroupedObjects, startRemoveGroupedObjects: props.startRemoveGroupedObjects, startNavigate: props.startNavigate })));
        }
    }
    return (react_1.default.createElement("section", { className: `survey-section survey-section-shortname-${props.shortname}` },
        react_1.default.createElement("div", { className: "survey-section__content" },
            widgetsComponentsByShortname['activePersonTitle'],
            widgetsComponentsByShortname['buttonSwitchPerson'],
            react_1.default.createElement("div", { className: "survey-trips-list-and-map-container" },
                react_1.default.createElement("ul", { className: `survey-trips-list ${selectedTripId ? 'full-width' : ''}` },
                    react_1.default.createElement("li", { className: "no-bullet", key: "survey-trips-list-person-trip-title" }, widgetsComponentsByShortname['personTripsTitle']),
                    tripsList,
                    react_1.default.createElement("li", { className: "no-bullet", key: "survey-trips-list-confirm-button" }, !selectedTripId && widgetsComponentsByShortname['buttonConfirmNextSection'])),
                !selectedTripId && (react_1.default.createElement("div", { className: 'survey-trips-map' }, widgetsComponentsByShortname['personVisitedPlacesMap']))))));
};
exports.SegmentsSection = SegmentsSection;
exports.default = (0, react_i18next_1.withTranslation)()((0, WithSurveyContextHoc_1.withSurveyContext)(exports.SegmentsSection));
//# sourceMappingURL=TripsAndSegmentsSection.js.map